export const SCREEN_SAVER_DATA = 'screenSaver/SCREEN_SAVER_DATA';

export const SCREEN_SAVER_IS_LOCKED = 'screenSaver/IS_LOCKED';
